var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c(
          "a",
          {
            staticClass: "active",
            attrs: {
              href:
                "/tjkStudy/groupTrain?groupId=" +
                _vm.groupId +
                "&groupName=" +
                _vm.groupName,
              target: "_blank"
            }
          },
          [_vm._v("群培训管理")]
        ),
        _vm._v(">\n    "),
        _c("span", [_vm._v("语音考核")]),
        _vm._v(">\n    "),
        _c("span", [_vm._v(_vm._s(_vm.codeName))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "end" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.endExam()
                }
              }
            },
            [_vm._v("结束考核")]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("剩余" + _vm._s(_vm.waitNum) + "人待考核")]),
          _vm._v(" "),
          _c("span", [_vm._v("当前拨打电话：" + _vm._s(_vm.callOutPhone))]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.changePhone } },
            [_vm._v("修改电话号码")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.status
        ? [
            _c("p", { staticClass: "nopeople" }, [
              _vm._v("名单中全部人员考核结束")
            ])
          ]
        : [
            _c("div", { staticClass: "current" }, [
              _c(
                "div",
                { staticClass: "tab" },
                [
                  _c("span", [_vm._v("当前考核人员：")]),
                  _vm._v(" "),
                  !!_vm.userList.current
                    ? [
                        _c("span", [
                          _vm._v(
                            "【" + _vm._s(_vm.userList.current.realName) + "】"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm.userList.current.userState == "Calling"
                              ? [_vm._v("正在外呼")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Confirmed"
                              ? [_vm._v("已确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Unconfirmed"
                              ? [_vm._v("未确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Call"
                              ? [_vm._v("通话中")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.current.userState == "Callend"
                              ? [_vm._v("通话结束")]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("table", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: { placeholder: "只能填写数字", clearable: "" },
                          model: {
                            value: _vm.score,
                            callback: function($$v) {
                              _vm.score = _vm._n($$v)
                            },
                            expression: "score"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: "",
                            placeholder: "不能超过200字",
                            clearable: ""
                          },
                          model: {
                            value: _vm.remark,
                            callback: function($$v) {
                              _vm.remark = $$v
                            },
                            expression: "remark"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "button" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Passed")
                          }
                        }
                      },
                      [_vm._v("通过考核并下一位")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "info" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Failed")
                          }
                        }
                      },
                      [_vm._v("不通过考核并下一位")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Retrial")
                          }
                        }
                      },
                      [_vm._v("建议复训并下一位")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.saveScore("Abandoned")
                          }
                        }
                      },
                      [_vm._v("学员放弃")]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "next" }, [
              _c(
                "div",
                { staticClass: "tab" },
                [
                  _c("span", [_vm._v("接下来考核人员：")]),
                  _vm._v(" "),
                  !!_vm.userList.next
                    ? [
                        _c("span", [
                          _vm._v(
                            "【" + _vm._s(_vm.userList.next.realName) + "】"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _vm.userList.next.userState == "Calling"
                              ? [_vm._v("正在外呼")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Confirmed"
                              ? [_vm._v("已确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Unconfirmed"
                              ? [_vm._v("未确认")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Call"
                              ? [_vm._v("通话中")]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userList.next.userState == "Callend"
                              ? [_vm._v("通话结束")]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    : [_vm._v("暂无")]
                ],
                2
              )
            ])
          ],
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c("h3", [_vm._v("考核名单")]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.list, border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "examineSeq",
                          label: "顺序",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "realName",
                          label: "考核人员",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "tjkNumber",
                          label: "淘金号",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", width: "180" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.examineState == "Examining"
                                  ? [_vm._v("正在考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Examined"
                                  ? [_vm._v("已考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Wait"
                                  ? [_vm._v("待考核")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.examineState == "Abandon"
                                  ? [_vm._v("学员放弃")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "startTime", label: "考核开始时间" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "duration", label: "考核时长" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.formatTime(scope.row.duration)) +
                                    "\n          "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.passState == "Passed"
                                  ? [_vm._v("是")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Failed"
                                  ? [_vm._v("否")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Abandoned"
                                  ? [_vm._v("学员放弃")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Retrial"
                                  ? [_vm._v("建议复训")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "AbandonInTrain"
                                  ? [_vm._v("培训老师同意放弃")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "change" }, [
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 外呼电话：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.change.callOutPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.change, "callOutPhone", $$v)
                    },
                    expression: "change.callOutPhone"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("综合得分")]),
      _vm._v(" "),
      _c("th", [_vm._v("备注")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97b46ddc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97b46ddc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/college/voiceExam.vue
// module id = 1170
// module chunks = 0